module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-slides-fill-053d4f87.svg";